export class GuildAPIError extends Error {}